/* Use this file for const enums that can be shared between tests and business logic only */

export const enum SigningMethod {
  QR = 'QR',
  RANDOM_READER = 'RANDOM_READER',
  RABO_SCANNER = 'RABO_SCANNER',
  OOB = 'OOB',
  APP = 'APP',
  USERKEY_TIN_APP = 'USERKEY_TIN_APP',
  ONE_CLICK_ID = 'ONE_CLICK_ID',
  TIN_WEB = 'TIN_WEB',
  EOTP = 'EOTP',
}

export const enum PreferredMethod {
  EOTP = 'eotp',
  QR = 'qr',
  RABO_SCANNER = 'rs',
  RANDOM_READER = 'rr',
}

export const enum Language {
  NL = 'nl',
  EN = 'en',
  ES = 'es',
  PT = 'pt',
}

export const enum ActionType {
  LOGIN = 'login',
  SIGN = 'sign',
}

export const enum Constants {
  REQUEST_TIMEOUT = 120000,
  SIGN_CODE_LENGTH = 8,
  DEFAULT_IBAN_PREFIX = 'NL•• RABO 0',
  ACC_NR_LENGTH = 10,
  DEFAULT_POLL_TIME = 2500,
  XSRF_COOKIE_NAME = 'RABOXSRFP',
  LANGUAGE_COOKIE_NAME = 'RABOLANG',
  METHOD_COOKIE_NAME = 'RABOASD',
  FNF_COOKIE_NAME = 'RABOFNF',
  EMAIL_COOKIE = 'RABOEMAIL',
  APP_PNP_COOKIE_NAME = 'PNP',
}

export const enum NotificationType {
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
}

export const enum HelpDeskReference {
  NONE = 'NONE',
  RN = 'RN',
  PRO = 'PRO',
  FL = 'FL',
}

export const enum SourceName {
  IDEAL = 'ideal',
  IDIN = 'idin',
  EMANDATES = 'emandates',
  OTHER = 'other',
  LOGIN = 'login',
  WERO = 'wero',
}

export const enum ColumnSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export const enum QrStatus {
  ISSUED = 'ISSUED',
  SCANNED = 'SCANNED',
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  REJECTED = 'REJECTED',
  BLOCKED = 'BLOCKED',
  TIMEOUT = 'TIMEOUT',
  ERROR = 'ERROR',
}

export const enum ReduxAction {
  NOTIFICATION_CLEAR = 'NOTIFICATION_CLEAR',
  NOTIFICATION_SHOW = 'NOTIFICATION_SHOW',
  OVERLAY_UPDATE = 'OVERLAY_UPDATE',
  OVERLAY_CLEAR = 'OVERLAY_CLEAR',
  INIT_METHODS = 'INIT_METHODS',
  SET_ACTIVE_METHOD = 'SET_ACTIVE_METHOD',
  SET_ACTIVE_METHOD_STATUS = 'SET_ACTIVE_METHOD_STATUS',
  SET_ALLOWED_METHODS = 'SET_ALLOWED_METHODS',
  SET_PREFERRED_METHOD = 'SET_PREFERRED_METHOD',
  SET_EMAIL_ADDRESS = 'SET_EMAIL_ADDRESS',
  SET_IS_EMAIL_ADDRESS_REMEMBERED = 'SET_IS_EMAIL_ADDRESS_REMEMBERED',
  CONFIG_INIT = 'CONFIG_INIT',
  SIGN_INIT = 'SIGN_INIT',
  NO_SIGN_INIT = 'NO_SIGN_INIT',
  SWITCH_LANGUAGE = 'SWITCH_LANGUAGE',
  UI_READY = 'UI_READY',
  CHALLENGE_DATA_UPDATE = 'CHALLENGE_DATA_UPDATE',
  CHALLENGE_DATA_CLEAR = 'CHALLENGE_DATA_CLEAR',
  SET_ACCOUNT_NUMBER = 'SET_ACCOUNT_NUMBER',
  SET_CARD_NUMBER = 'SET_CARD_NUMBER',
  SET_IS_CARD_REMEMBERED = 'SET_IS_CARD_REMEMBERED',
  SET_IS_CARD_SWITCH_ALLOWED = 'SET_IS_CARD_SWITCH_ALLOWED',
  SET_IS_CARD_VALID = 'SET_IS_CARD_VALID',
  SET_DEBIT_CARD = 'SET_DEBIT_CARD',
  SET_CREDIT_CARD = 'SET_CREDIT_CARD',
  SET_SIGNING_LIMITATION_INFO = 'SET_SIGNING_LIMITATION_INFO',
}
export const enum LoginView {
  EMAIL = 'EMAIL',
  AUTHENTICATED = 'AUTHENTICATED',
}

export const enum Factor {
  EMAIL_PASSWORD = 'EMAIL_PASSWORD',
  PASSWORD = 'PASSWORD',
}

export const enum CreditCardType {
  MASTERCARD = 'MASTERCARD',
  VISA = 'VISA',
}

export const enum DisplayType {
  SCREEN_WITHOUT_HEADER = '31',
  HEADER_WITHOUT_CANCEL_BUTTON = '32',
}

export const enum RandomReaderInstructionTypes {
  RANDOM = 'RANDOM',
  AMOUNT = 'AMOUNT',
  ACCOUNT = 'ACCOUNT',
  NUMBER = 'NUMBER',
  COUNT = 'COUNT',
}

export enum LevelRequested {
  HIGH = 'HIGH',
  MEDIUM_ADVANCED = 'MEDIUM_ADVANCED',
  MEDIUM_PSD = 'MEDIUM_PSD',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}

export enum SigningLimitation {
  NO_SIGNING_ALLOWED = 'NO_SIGNING_ALLOWED',
  HIGH_RISK_NOT_ALLOWED = 'HIGH_RISK_NOT_ALLOWED',
  HIGH_RISK_CHANNEL_SEPARATION = 'HIGH_RISK_CHANNEL_SEPARATION',
}
